
import { Component, OnInit, ViewChild } from '@angular/core';
import { DeviceDetectorService } from '../../../../../services/device-detector.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import { WalletService } from '../../../../../services/wallet';
@Component({
  selector: 'app-e-commerce',
  templateUrl: './e-commerce.component.html',
  styleUrl: './e-commerce.component.scss'
})
export class ECommerceComponent implements OnInit {
  allData: any[] = [];
  totalItems = 0;
  isAr: boolean = localStorage.getItem("language") == "ar";
  displayedColumns: string[] = ['name', 'username', 'phone', 'balance', 'actions'];
  contentReady: boolean = true;
  noData: boolean = false;
  isMobile: boolean = false;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  dataSource: MatTableDataSource<any>;
  newPage: number = 1;
  addBalancePopUp: boolean = false;
  amount!: any;
  note!: any;
  userId!: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private walletService: WalletService,
    private deviceService: DeviceDetectorService,
  ) {
    this.dataSource = new MatTableDataSource(this.allData);
  }
  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.loadAllUsers();
  }
  onPaginateChange(event: PageEvent) {
    const newPage = event.pageIndex + 1;
    this.newPage = newPage;
  }
  loadAllUsers(): void {
    this.walletService.getAllUsersWithWallets().subscribe({
      next: (res) => {
        this.allData = res;
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
      },
      error: (err) => console.error(err)
    });
  }
  addCredit(userId: any) {
    this.userId = userId;
    this.addBalancePopUp = true;
  }
  close() {
    this.addBalancePopUp = false;
  }
  onSubmit() {

    this.walletService.addWalletBalance(this.userId, this.amount, this.note).subscribe({
      next: (res) => {
        this.close();
        this.loadAllUsers();

      },
      error: (err) => console.error(err)
    });
  }
}
